import { CompanyUsersState, CompanyUsersTypes } from './types';

const INITIAL_STATE: CompanyUsersState = {
  companyUsersList: [],
  companyUsersData: {
    name: '',
    document: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
  checkCompanyUsersList: [],
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// Check Company Users
const checkCompanyUsersRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyUsersList: INITIAL_STATE.checkCompanyUsersList,
});

const checkCompanyUsersSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  checkCompanyUsersList: action.payload.checkCompanyUsersList,
});

const checkCompanyUsersFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Charge Request Exter
const chargeRequestExternRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const chargeRequestExternSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const chargeRequestExternFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// List Company Users
const listCompanyUsersRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyUsersList: INITIAL_STATE.companyUsersList,
});

const listCompanyUsersSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyUsersList: action.payload.companyUsersList,
  totalCount: action.payload.totalCount,
});

const listCompanyUsersFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyUsersList: INITIAL_STATE.companyUsersList,
});

// Create Company Users
const createCompanyUsersRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyUsersData: INITIAL_STATE.companyUsersData,
});

const createCompanyUsersSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyUsersData: action.payload.companyUsersData,
});

const createCompanyUsersFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyUsersData: INITIAL_STATE.companyUsersData,
});

// Update Company Users
const updateCompanyUsersRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateCompanyUsersSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyUsersData: action.payload.companyUsersData,
});

const updateCompanyUsersFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Company Users
const deleteCompanyUsersRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteCompanyUsersSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteCompanyUsersFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Company User
const deleteCompanyUserRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteCompanyUserSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteCompanyUserFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

const reducer = createReducer(INITIAL_STATE, {
  [CompanyUsersTypes.CHECK_COMPANY_USERS_REQUEST]: checkCompanyUsersRequest,
  [CompanyUsersTypes.CHECK_COMPANY_USERS_SUCCESS]: checkCompanyUsersSuccess,
  [CompanyUsersTypes.CHECK_COMPANY_USERS_FAILURE]: checkCompanyUsersFaliure,

  [CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_REQUEST]: chargeRequestExternRequest,
  [CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_SUCCESS]: chargeRequestExternSuccess,
  [CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_FAILURE]: chargeRequestExternFaliure,

  [CompanyUsersTypes.LIST_COMPANY_USERS_REQUEST]: listCompanyUsersRequest,
  [CompanyUsersTypes.LIST_COMPANY_USERS_SUCCESS]: listCompanyUsersSuccess,
  [CompanyUsersTypes.LIST_COMPANY_USERS_FAILURE]: listCompanyUsersFaliure,

  [CompanyUsersTypes.CREATE_COMPANY_USERS_REQUEST]: createCompanyUsersRequest,
  [CompanyUsersTypes.CREATE_COMPANY_USERS_SUCCESS]: createCompanyUsersSuccess,
  [CompanyUsersTypes.CREATE_COMPANY_USERS_FAILURE]: createCompanyUsersFailure,

  [CompanyUsersTypes.UPDATE_COMPANY_USERS_REQUEST]: updateCompanyUsersRequest,
  [CompanyUsersTypes.UPDATE_COMPANY_USERS_SUCCESS]: updateCompanyUsersSuccess,
  [CompanyUsersTypes.UPDATE_COMPANY_USERS_FAILURE]: updateCompanyUsersFailure,

  [CompanyUsersTypes.DELETE_COMPANY_USERS_REQUEST]: deleteCompanyUsersRequest,
  [CompanyUsersTypes.DELETE_COMPANY_USERS_SUCCESS]: deleteCompanyUsersSuccess,
  [CompanyUsersTypes.DELETE_COMPANY_USERS_FAILURE]: deleteCompanyUsersFailure,

  [CompanyUsersTypes.DELETE_COMPANY_USER_REQUEST]: deleteCompanyUserRequest,
  [CompanyUsersTypes.DELETE_COMPANY_USER_SUCCESS]: deleteCompanyUserSuccess,
  [CompanyUsersTypes.DELETE_COMPANY_USER_FAILURE]: deleteCompanyUserFailure,
});

export default reducer;
